import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { FiltersComponent } from 'src/app/common/filters.component';
import { Data2Service } from 'src/app/common/data2.service';
import { DateService } from 'src/app/common/date.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { ActivatedRoute, Router } from '@angular/router';
import { QuestionService } from 'src/app/common/question-dialog/question-dialog.service';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { BagPaymentListService } from './bag-payment-list.service';
import { DataBagService } from 'src/app/common/data-bag.service';
import { Subscription } from 'rxjs';
import { Status, statusMappings } from 'src/app/common/enums/Status';
import { OrganizationResponse } from '@/common/models/response.model';
import { Organization } from '@/reservation/reservation.model';

@Component({
	selector: 'app-bag-payment-list',
	templateUrl: './bag-payment-list.component.html',
	styleUrls: ['./bag-payment-list.component.scss'],
})
export class BagPaymentListComponent implements OnInit, OnDestroy {
	protected itemsBeforeDataLoad = 6;
	protected paymentColumns = [
		{ id: 'payment', name: 'Płatność' },
		{ id: 'posting', name: 'Księgowanie' },
		{ id: 'status', name: 'Status' },
		{ id: 'kind', name: 'Rodzaj' },
		{ id: 'amount', name: 'Kwota' },
		{ id: 'payer', name: 'Płatnik' }, //zmienić id
		{ id: 'bankAccountPosting', name: 'Konto wpłaty' },
		{ id: 'bankAccountIncoming', name: 'Konto płatnika' },
		{ id: 'invoiceNumber', name: 'Numer faktury' },
		{ id: 'tableId', name: 'Numer rezerwacji' },
		{ id: 'reservationStatus', name: 'Status rezerwacji' },
		{ id: 'reservationSeller', name: 'Agent' },
	];
	protected summaryColumns = [
		{ id: 'amount', name: 'Suma kwoty' },
		{ id: 'currency', name: 'Waluta' },
	];

	filters: any;
	parameters: any = {
		organizations: [],
		bankAccounts: [],
		status: [
			{ id: 'PE', description: 'W trakcie' },
			{ id: 'CO', description: 'Zakończona' },
			{ id: 'CA', description: 'Anulowana' },
		],
		paymentKinds: [],
		reservationStatus: [
			{ id: Status.OPTION, name: statusMappings[Status.OPTION] },
			{ id: Status.CONFIRMED, name: statusMappings[Status.CONFIRMED] },
			{ id: Status.CANCELED, name: statusMappings[Status.CANCELED] },
			{ id: Status.REJECTED, name: statusMappings[Status.REJECTED] },
		],
		currency: [],
		profileData: [],
		agencies: [],
	};

	protected itemsBeforeLoadData: string[] = [];
	protected filtersComponent = new FiltersComponent(this.api, this.route, this.router);
	tableRows: any[] = [];
	data: any[] = [];
	subscribtionPayment$: Subscription;
	subscribtionUsers: Subscription;

	constructor(
		public _service: BagPaymentListService,
		protected api: Data2Service,
		protected date: DateService,
		protected infobox: InfoboxService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected question: QuestionService,
		protected bag: DataBagService,
		protected loader: LoaderService,
	) {}

	ngOnInit(): void {
		this.loader.show();
		this.loadBefore();
	}

	ngOnDestroy(): void {
		this.subscribtionPayment$?.unsubscribe();
	}

	loadData() {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.loader.show();
		// I considered removing that limit, but I left it cause removal could cause issues.
		// For example someone could send a request that wants to get too many records and it could turn down the BAG.
		// I'm afraid as long as BE won't fix it on their side, we could not get rid of that limits.
		// That's why I just tripled that limit.
		const params = this.api.getChecked({ ...this.filters, limit: 30000 }, this.parameters);
		this._service.loadPayments(params);
		if (!this.subscribtionPayment$) {
			this.subscribtionPayment$ = this._service.payment$.subscribe((data) => {
				this.data = this.convertData(data);
			});
		}
	}

	loadBefore(): void {
		this.bag.get('/organization/?limit=9999&is_oskar=true', (result: OrganizationResponse, error) => {
			if (result) {
				const organizations = result.results.map((organization: Organization) => ({
					...organization,
					id: organization.id.toString(),
				}));
				this.parameters.organizations = organizations;
			}
			this.loadData();
		});
		this.bag.get('/organization/?limit=9999&is_oskar=false', (result: OrganizationResponse, error) => {
			if (result) {
				const agencies = result.results.map((agency: Organization) => ({
					...agency,
					id: agency.id.toString(),
				}));
				this.parameters.agencies = agencies;
			}
			this.loadData();
		});
		this.bag.get('/bank_account/?limit=99999', (result, error) => {
			result.results?.forEach((obj) => (obj.id = obj.id.toString()));
			this.parameters.bankAccounts = result.results;
			this.loadData();
		});
		this.bag.get('/payment/kind/?limit=99999', (result, error) => {
			result.results?.forEach((obj) => (obj.id = obj.id.toString()));
			this.parameters.paymentKinds = result.results;
			this.loadData();
		});
		this.bag.get('/currency/?limit=99999', (result, error) => {
			result.results?.forEach((obj) => (obj.id = obj.id.toString()));
			this.parameters.currency = result.results;
			this.loadData();
		});
		this._service.loadUsers(() => {
			this.loadData();
		});
		if (this.subscribtionUsers) this.subscribtionUsers.unsubscribe();
		this.subscribtionUsers = this._service.users.subscribe((data) => {
			this.parameters.profileData = data;
		});
	}

	filtersOpen() {
		this.filtersComponent.filtersOpen();
	}

	filtersSelected(data) {
		this.filters = data;
		this.loadData();
	}

	protected generateSummary(data: any): any[] {
		let sumAmount;
		sumAmount = data.results?.reduce((a, b) => {
			const i = a.findIndex((x) => x.currency === b.currency);
			if (i === -1) {
				a.push({
					currency: b.currency,
					amount: b.amount,
				});
			} else {
				a[i].amount += b.amount;
			}
			return a;
		}, []);
		return this.parseSummaryTable(sumAmount);
	}

	protected parseSummaryTable(data: any[]): any[] {
		return data?.map((obj) => {
			const currency = this.findObject(this.parameters.currency, obj.currency);
			obj.currency = currency ? currency?.code : '?';
			obj.amount = this.parseAmountTable(obj.amount);
			return obj;
		});
	}

	protected parseAmountTable(value: number): string {
		return (value * 0.01).toFixed(2);
	}

	protected findObject(arr, item) {
		return arr?.find((objfind) => objfind.id == item);
	}

	protected praseDateTable(date): string {
		return date?.split('T')[0];
	}

	convertData(data: any) {
		data.results.summary = this.generateSummary(data);
		this.parameters.bankAccounts.map((obj) => {
			return (obj.organization = this.findObject(this.parameters?.organizations, obj.organization));
		});
		data.results.forEach((obj) => {
			obj.payment = this.praseDateTable(obj.payment);
			obj.posting = this.praseDateTable(obj.posting);
			const status = this.findObject(this.parameters.status, obj.status);
			obj.status = status ? status?.description : '?';
			obj.reservationStatus = statusMappings[obj.reservationStatus] ? statusMappings[obj.reservationStatus] : '?';
			obj.payer = this.getPayer(obj);
			const bankAccountPosting = this.findObject(this.parameters.bankAccounts, obj.bankAccountPosting);
			obj.bankAccountPosting = bankAccountPosting ? bankAccountPosting?.number : '?';
			obj.kind = obj.kind?.description;
			const currency = this.findObject(this.parameters.currency, obj.currency);
			obj.amount = this.parseAmountTable(obj.amount) + ' ' + currency?.code;
			obj.reservationSeller = this.findObject(this.parameters.agencies, obj.reservationSeller)?.shortName;
			obj.tableId = {
				label: `BAG ${obj.tableId}`,
				isLink: true,
				route: `reservation/${obj.tableId}`,
			};
			return obj;
		});
		this.loader.hide();
		return data.results;
	}

	private getPayer(element): string {
		if (element.organization) {
			return this.findObject(this.parameters.organizations, element.organization)?.shortName;
		} else {
			return `${element.userData.firstName} ${element.userData.lastName}`;
		}
	}
}
